import React, { useEffect } from 'react';
import { Typography, Card, Row, Col } from 'antd';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IPen from 'icons/IPen';
import { dateToString } from 'utils/utilsSFS';
import moment from 'moment';
import Title from 'components/Title';
import DownloadPDF from './DownloadPDF';

const { Text } = Typography;
const { Title: AntTitle } = Typography;

interface ProductRecapContentProps {
  form: any;
  partlist: any[];
  ratelist: any[];
  feesList: any[];
  servicesList?: any[];
  triggersList?: any[];
  amortizationList?: any[];
  sortieData?: any;
  conversionList: any[];
  isInspect?: boolean;
  isEditable?: boolean;
  isCompleted?: boolean;
  onEditSection?: (sectionIndex: number) => void;
}

const ProductRecapContent: React.FC<ProductRecapContentProps> = ({
  form,
  ratelist = [],
  feesList = [],
  partlist = [],
  triggersList = [],
  amortizationList = [],
  sortieData = {},
  conversionList = [],
  isInspect = false,
  isEditable = false,
  isCompleted = false,
  onEditSection,
}) => {

  useEffect(() => {
    console.log("ratelist", ratelist)
    console.log("partlist", partlist)

  }, [ratelist, partlist])

  const handleEditClick =
    (sectionIndex: number) => (e: { stopPropagation: () => void }) => {
      e.stopPropagation();
      if (onEditSection) {
        onEditSection(sectionIndex);
      }
    };


  const getFormValue = (fieldName: string, fallback: any = '') => {
    try {
      return form?.getFieldValue?.(fieldName) ?? fallback;
    } catch {
      return fallback;
    }
  };
  const [displayData, setDisplayData] = React.useState<any>({});
  React.useEffect(() => {
    const currentFormValues = form.getFieldsValue();
    const combinedData = { ...form, ...currentFormValues };
    setDisplayData(combinedData);
  }, [form]);


  // const groupedRates = React.useMemo(() => {
  //   const ratesByPeriod: {
  //     [key: string]: {
  //       nsc?: any;
  //       client?: any;
  //     };
  //   } = {};


  //   ratelist.forEach((item) => {
  //     if (item.nsc && item.client) {
  //       const periodNumber = item.nsc.ctesorder || item.client.ctesorder;
  //       if (!ratesByPeriod[periodNumber]) {
  //         ratesByPeriod[periodNumber] = {
  //           nsc: item.nsc,
  //           client: item.client,
  //         };
  //       } else {

  //         if (item.nsc) ratesByPeriod[periodNumber].nsc = item.nsc;
  //         if (item.client) ratesByPeriod[periodNumber].client = item.client;
  //       }
  //     }
  //   });


  //   ratelist.forEach((item) => {
  //     if (!item.nsc && !item.client) {
  //       const periodNumber = item.ctesorder;
  //       const side = item.prefinsteptype === 'PART' ? 'nsc' : 'client';

  //       if (!ratesByPeriod[periodNumber]) {
  //         ratesByPeriod[periodNumber] = {
  //           nsc: side === 'nsc' ? item : {},
  //           client: side === 'client' ? item : {},
  //         };
  //       } else {

  //         if (side === 'nsc') ratesByPeriod[periodNumber].nsc = item;
  //         if (side === 'client') ratesByPeriod[periodNumber].client = item;
  //       }
  //     }
  //   });

  //   return Object.values(ratesByPeriod);
  // }, [ratelist]);

  // Extract amortization steps
  const amortizationSteps = React.useMemo(() => {
    const flatSteps = ratelist.flatMap((item) => {
      if (item.nsc && item.client) {
        return [
          {
            ...item.nsc,
            side: 'nsc',
            ctesorder: item.nsc.ctesorder || item.client.ctesorder,
          },
          {
            ...item.client,
            side: 'client',
            ctesorder: item.client.ctesorder || item.nsc.ctesorder,
          },
        ];
      }
      return [item];
    });

    return flatSteps.filter((step) => step.prefinsteptype === 'CAP');
  }, [ratelist]);


  const normalizedAmortizationList =
    amortizationList.length > 0 ? amortizationList : amortizationSteps;
  return (
    <div className="container-stepper mt-4 taux productlist">
      {/* General Information Section */}

      <Row
        gutter={16}
        align="middle"
        justify="space-between"
        className="mb-2 align-center"
      >
        <Col>
          {isCompleted && (
            <Title
              comcode="infoTRecap"
              level={4}
              className="ut-updateTP-title mb-7 mt-10"
            />
          )}
        </Col>
        <Col className="mt-2">
          {!isCompleted && (
            <DownloadPDF
              pageName={'Product-Recap-' + moment().format('DD-MM-YYYY')}
              contentElementId="pdf-content"
            />
          )}
        </Col>
      </Row>
      <div id="pdf-content">
        <div className="mb-6">
          <Row>
            <Col span={17}>
              <AntTitle className="mb-2 color-blue" level={3}>
                <GetLabel label="overall" />
                {isEditable && (
                  <IPen
                    onClick={handleEditClick(0)}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </AntTitle>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={10}>
              <div className="mb-3">
                <GetLabel label="startdate" className="font-weight-400 mr-4" />
                <Text className="font-weight-500">
                  {getFormValue('startdate')
                    ? dateToString(
                      moment(getFormValue('startdate')).format('DD/MM/YYYY')
                    )
                    : '-'}
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="productfamily"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  {getFormValue('prcode')}
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="productname"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  {getFormValue('offercode')}
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="maxproductduration"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  {getFormValue('durationmax')} <GetLabel label="days" />
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="flaguseassetgrossamount"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  {getFormValue('flaguseassetgrossamount') ? 'TTC' : 'HT'}
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="depreciation"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  <GetLabel label={getFormValue('offerdepreciation')} />
                </Text>
              </div>
            </Col>
            <Col
              span={14}
              style={{ borderLeft: '1px solid gray' }}
              className="pl-6 pr-6"
            >
              <div className="mb-3">
                <GetLabel label="target" className="font-weight-400 mr-4" />
                <Text className="font-weight-500">
                  <GetLabel label={getFormValue('offertarget')} />
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel label="brands" className="font-weight-400 mr-4" />
                <Text className="font-weight-500">
                  {getFormValue('brandlist', [])?.map(
                    (brand: string, index: number) => (
                      <React.Fragment key={index}>
                        {index > 0 && ', '}
                        <div style={{ display: 'inline-block' }}>{brand}</div>
                      </React.Fragment>
                    )
                  )}
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="productdescription"
                  className="font-weight-400 mr-4 mb-3"
                />
                <Text className="font-weight-500">
                  {getFormValue('offerlabel')}
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="franchiseperiod"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  {getFormValue('partnbdaysmax')} <GetLabel label="days" />
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="financementType"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  <GetLabel label={getFormValue('financementType')} />
                </Text>
              </div>
            </Col>
          </Row>
        </div>

        {/* Part Section */}
        <div>
          <Col span={9}>
            <AntTitle className="mb-2 color-blue" level={3}>
              <GetLabel label="part" />
              {isEditable && (
                <IPen
                  onClick={handleEditClick(1)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </AntTitle>
          </Col>
          <Row
            className="mb-4"
            gutter={16}
            align="middle"
            justify="space-between"
          >
            <Col
              span={isInspect ? 12 : 2}
              style={{
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                textAlign: 'center',
              }}
            >
              <GetLabel
                label="period"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 2} className="pl-0">
              <GetLabel
                label="startday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 2} className="pl-0 pr-8">
              <GetLabel
                label="nbofdays"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 2} className="pl-0">
              <GetLabel
                label="endday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 6} className="pl-0">
              <GetLabel
                label="nsccondition"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            {/* <Col span={isInspect ? 12 : 6} className="pl-0">
              <GetLabel
                label="clicondition"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col> */}
          </Row>
          <div>
            {partlist?.length === 0 && (
              <Card
                style={{ zIndex: 100, padding: 8 }}
                className="no-border-radius no-border text-center mb-2"
              >
                <GetLabel
                  label="tauxVid"
                  className="font-size-13 gray-color "
                />
              </Card>
            )}
            {partlist.map((item: any, index: number) => (
              <div
                key={`rate-period-${index}`}
                style={{ zIndex: 100, padding: 8 }}
                className="activity-card mb-2"
              >
                <Row gutter={16} align="middle" justify="space-between">
                  <Col span={2} style={{ justifyItems: 'center' }}>
                    <div className="circle-number">
                      {item?.nsc?.ctesorder ||
                        item?.ctesorder ||
                        index + 1}
                    </div>
                  </Col>
                  <Col span={2}>
                    {item?.nsc?.ratestartday ||
                      item?.ratestartday ||
                      '-'}
                  </Col>
                  <Col span={2}>
                    {item?.nsc?.ratenbdaysmax ||
                      item?.ratenbdaysmax ||
                      '-'}
                  </Col>
                  <Col span={2}>
                    {item?.nsc?.rateendday || item?.rateendday || '-'}
                  </Col>
                  <Col span={6} className="pl-0">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="rateformula" />
                      </span>{' '}
                      {(item?.nsc?.nscrateformulalabel ? item?.nsc?.nscrateformulalabel : item?.nscrateformulalabel) || '-'}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="appliedrate" />
                      </span>{' '}
                      {`${item?.nsc?.nscappliedrate != null
                        ? item?.nsc?.nscappliedrate
                          .toString()
                          .replace('.', ',') + ' %'
                        : item?.nscappliedrate != null ? item?.nscappliedrate
                          .toString()
                          .replace('.', ',') + ' %' : '-'
                        }`}
                    </div>
                  </Col>
                  {/* <Col span={6} className="pl-0 ">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="rateformula" />
                      </span>{' '}
                      {item?.client?.rateformula || '-'}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="appliedrate" />
                      </span>{' '}
                      {`${item?.client?.clientappliedrate != null
                        ? item?.client?.clientappliedrate
                          .toString()
                          .replace('.', ',') + ' %'
                        : '-'
                        }`}
                    </div>
                  </Col> */}
                </Row>
              </div>
            ))}
          </div>
        </div>


        {/* Rates Section */}
        <div>
          <Col span={9}>
            <AntTitle className="mb-2 color-blue" level={3}>
              <GetLabel label="rates" />
              {isEditable && (
                <IPen
                  onClick={handleEditClick(1)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </AntTitle>
          </Col>
          <Row
            className="mb-4"
            gutter={16}
            align="middle"
            justify="space-between"
          >
            <Col
              span={isInspect ? 12 : 2}
              style={{
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                textAlign: 'center',
              }}
            >
              <GetLabel
                label="period"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 2} className="pl-0">
              <GetLabel
                label="startday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 2} className="pl-0 pr-8">
              <GetLabel
                label="nbofdays"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 2} className="pl-0">
              <GetLabel
                label="endday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            {/* <Col span={isInspect ? 12 : 6} className="pl-0">
              <GetLabel
                label="nsccondition"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col> */}
            <Col span={isInspect ? 12 : 6} className="pl-0">
              <GetLabel
                label="clicondition"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
          </Row>
          <div>
            {ratelist?.length === 0 && (
              <Card
                style={{ zIndex: 100, padding: 5 }}
                className="no-border-radius no-border text-center mb-2"
              >
                <GetLabel
                  label="tauxVid"
                  className="font-size-13 gray-color "
                />
              </Card>
            )}
            {ratelist.map((item: any, index: number) => (
              <div
                key={`rate-period-${index}`}
                style={{ zIndex: 100, padding: 5 }}
                className="activity-card mb-2"
              >
                <Row gutter={16} align="middle" justify="space-between">
                  <Col span={2} style={{ justifyItems: 'center' }}>
                    <div className="circle-number">
                      {item?.client?.ctesorder ||
                        item?.ctesorder ||
                        index + 1}
                    </div>
                  </Col>
                  <Col span={2}>
                    {item?.client?.ratestartday ||
                      item?.ratestartday ||
                      '-'}
                  </Col>
                  <Col span={2}>
                    {item?.client?.ratenbdaysmax ||
                      item?.ratenbdaysmax ||
                      '-'}
                  </Col>
                  <Col span={2}>
                    {item?.client?.rateendday || item?.rateendday || '-'}
                  </Col>
                  {/* <Col span={6} className="pl-0">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="rateformula" />
                      </span>{' '}
                      {item?.nsc?.nscrateformula || '-'}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="appliedrate" />
                      </span>{' '}
                      {`${item?.nsc?.nscappliedrate != null
                        ? item?.nsc?.nscappliedrate
                          .toString()
                          .replace('.', ',') + ' %'
                        : '-'
                        }`}
                    </div>
                  </Col> */}
                  <Col span={6} className="pl-0 ">
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="rateformula" />
                      </span>{' '}
                      {(item?.client?.rateformulalabel ? item?.client?.rateformulalabel : item?.rateformulalabel) || '-'}
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span className="gray-color">
                        <GetLabel label="appliedrate" />
                      </span>{' '}


                      {`${item?.client?.clientappliedrate != null
                        ? item?.client.clientappliedrate
                          .toString()
                          .replace('.', ',') + ' %'
                        : item?.clientappliedrate != null ? item?.clientappliedrate
                          .toString()
                          .replace('.', ',') + ' %' : '-'
                        }`}
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </div>

        {/* Fees Section */}
        <div>
          <Col span={9}>
            <AntTitle className="mb-2 color-blue mt-4" level={3}>
              <GetLabel label="fees" />
              {isEditable && (
                <IPen
                  onClick={handleEditClick(2)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </AntTitle>
          </Col>
          <Row
            className="mb-4 pl-1 pr-1"
            gutter={10}
            align="middle"
            justify="center"
          >
            {/* Column headers for fees */}
            <Col span={isInspect ? 12 : 3} className="align-center text-center">
              <GetLabel
                label="type"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 3} className="align-center text-center">
              <GetLabel
                label="category"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 3} className="align-center text-center">
              <GetLabel
                label="frequency"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={isInspect ? 12 : 2} className="align-center text-center">
              <GetLabel
                label="startday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col
              span={isInspect ? 12 : 2}
              className="align-center text-center pr-4 pl-4"
            >
              <GetLabel
                label="endday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col
              span={isInspect ? 12 : 2}
              className="align-center text-center pr-4 pl-4"
            >
              <GetLabel
                label="nbofdays"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col
              span={isInspect ? 12 : 3}
              className="align-center text-center pr-4 pl-4"
            >
              <GetLabel
                label="firstbilling"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col
              span={isInspect ? 12 : 4}
              className="align-center text-center pr-8 pl-4"
            >
              <GetLabel
                label="amountrate"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col
              span={isInspect ? 12 : 2}
              className="align-center text-center "
            >
              <GetLabel
                label="billingto"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
          </Row>

          {feesList?.length === 0 && (
            <Card
              style={{ zIndex: 100 }}
              className="no-border-radius no-border text-center mb-2"
            >
              <GetLabel
                label="fees_empty"
                className="font-size-13 gray-color "
              />
            </Card>
          )}

          {feesList?.map((item) => (
            <div
              key={item.key || item.id}
              style={{ zIndex: 100, padding: 5 }}
              className="activity-card mb-2"
            >
              <Row gutter={30} className="align-center">
                <Col span={isInspect ? 12 : 3} style={{ textAlign: 'center' }}>
                  {item.servcalculationmethod ? (
                    <GetLabel label={item.servcalculationmethod} />
                  ) : item.servcalculationmethodlabel ? (
                    item.servcalculationmethodlabel
                  ) : (
                    '-'
                  )}
                </Col>
                <Col span={isInspect ? 12 : 3} style={{ textAlign: 'center' }}>
                  {item.servcategory ? (
                    <GetLabel label={item.servcategory} />
                  ) : item.servcategorylabel ? (
                    item.servcategorylabel
                  ) : (
                    '-'
                  )}
                </Col>
                <Col
                  span={isInspect ? 12 : 3}
                  className="pr-0"
                  style={{ textAlign: 'center' }}
                >
                  {item.servduration ? (
                    <GetLabel label={item.servduration} />
                  ) : item.servdurationlabel ? (
                    item.servdurationlabel
                  ) : (
                    '-'
                  )}
                </Col>
                <Col span={2} style={{ textAlign: 'center' }}>
                  {item.servstartday || '-'}
                </Col>
                <Col span={2} style={{ textAlign: 'center' }}>
                  {item.servendday || '-'}
                </Col>
                <Col span={2} style={{ textAlign: 'center' }}>
                  {item.servperiodicity || '-'}
                </Col>
                <Col span={3} style={{ textAlign: 'center' }}>
                  {item.servbillingday || '-'}
                </Col>
                <Col
                  span={isInspect ? 12 : 4}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {item.servfixedamount ? (
                    <>
                      {/* <span className="gray-color">
                        <GetLabel label="amount" />
                      </span>{' '} */}
                      {`${item.servfixedamount != null
                        ? item.servfixedamount
                          .toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          })
                          .replace('.', ',') + ' €'
                        : '-'
                        }`}
                    </>
                  ) : (
                    <>
                      {/* <span className="gray-color">
                        <GetLabel label="rate" />
                      </span>{' '} */}
                      {`${item.feesrate != null
                        ? item.feesrate.toString().replace('.', ',') + ' %'
                        : '-'
                        }`}
                    </>
                  )}
                </Col>
                <Col span={2} style={{ textAlign: 'center' }}>
                  {item.tprole === 'OEM' ? 'NSC' : item.tprole}
                </Col>
              </Row>
            </div>
          ))}
        </div>
        {/* Amortization Section */}
        <div>
          <Col span={9}>
            <AntTitle className="mb-2 color-blue mt-4" level={3}>
              <GetLabel label="amortization" />
              {isEditable && (
                <IPen
                  onClick={handleEditClick(3)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </AntTitle>
          </Col>
          <Row
            className="mb-4 pl-1 pr-1"
            gutter={10}
            align="middle"
            justify="center"
          >
            <Col span={5} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="startday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={5} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="endday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={5} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="periodicity"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={5} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="billingday"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={4} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="amountrate"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
          </Row>

          {normalizedAmortizationList?.length === 0 ? (
            <Card
              style={{ zIndex: 100 }}
              className="no-border-radius no-border text-center mb-2"
            >
              <GetLabel
                label="amortissement-empty"
                className="font-size-13 gray-color"
              />
            </Card>
          ) : (
            normalizedAmortizationList.map((item, index) => (
              <div
                key={item.key || item.id || index}
                style={{ zIndex: 100, padding: 5 }}
                className="activity-card mb-2"
              >
                {/* Ancienne version commentée :
        <Row gutter={16} align="middle" justify="space-between">
          <Col span={4}>{item.amtstartday || '-'}</Col>
          <Col span={4}>{item.amtendday || '-'}</Col>
          <Col span={4}>{item.cteperiodicity || '-'}</Col>
          <Col span={4}>{item.amortbillingday || '-'}</Col>
          <Col span={4}>
            <span className="gray-color">
              <GetLabel label="rate" />{' '}
            </span>
            {item.cteamortizedcoef || '-'}%
          </Col>
        </Row>
        */}

                {/* Version mappée conforme à prefinsteptype = CAPITAL */}
                <Row gutter={16} align="middle" justify="space-between">
                  <Col span={4} style={{ textAlign: 'center' }}>
                    {item.amtstartday ?? item.ratestartday ?? '-'}
                  </Col>
                  <Col span={4} style={{ textAlign: 'center' }}>
                    {item.amtendday ?? item.rateendday ?? '-'}
                  </Col>
                  <Col span={4} style={{ textAlign: 'center' }}>
                    {item.cteperiodicity ?? item.ctesperiodicity ?? '-'}
                  </Col>
                  <Col span={4} style={{ textAlign: 'center' }}>
                    {item.amortbillingday ?? item.ratenbdaysmax ?? '-'}
                  </Col>
                  <Col span={4}>
                    <span className="gray-color">
                      <GetLabel label="rate" />{' '}
                    </span>

                    {item.cteamortizedcoef != null
                      ? `${Number(item.cteamortizedcoef)} %`
                      : item.ctesamortizedcoef != null
                        ? `${Number(item.ctesamortizedcoef)} %`
                        : '-'}
                  </Col>
                </Row>
              </div>
            ))
          )}
        </div>

        {/* Add Triggers Section */}
        <div>
          <Col span={9}>
            <AntTitle className="mb-2 color-blue mt-4" level={3}>
              <GetLabel label="triggers" />
              {isEditable && (
                <IPen
                  onClick={handleEditClick(4)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </AntTitle>
          </Col>
          <Row
            className="mb-4 pl-1 pr-1"
            gutter={16}
            align="middle"
            justify="space-between"
          >
            <Col span={6} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="triggerEventId"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={6} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="timeDelayDays"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={6} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="triggerconsequence"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={6} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="offerid"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
          </Row>

          {triggersList?.length === 0 ? (
            <Card
              style={{ zIndex: 100 }}
              className="no-border-radius no-border text-center mb-2"
            >
              <GetLabel
                label="triggers-empty"
                className="font-size-13 gray-color"
              />
            </Card>
          ) : (
            triggersList?.map((item, index) => (
              <div
                key={item.key || item.id}
                style={{ zIndex: 100, padding: 5 }}
                className="activity-card mb-2"
              >
                <Row gutter={16} align="middle" justify="space-between">
                  <Col span={6} className="text-center">
                    {item.triggerEventLabel || '-'}
                  </Col>
                  <Col span={6} className="text-center">
                    {item.nbDays || '-'}
                  </Col>
                  <Col span={6} className="text-center">
                    {item.triggerconsequence || '-'}
                  </Col>
                  <Col span={6} className="text-center">
                    {item.offerlabel
                      ? item.offerlabel
                      : item.offerIdTarget || '-'}
                  </Col>
                </Row>
              </div>
            ))
          )}
        </div>

        {/* Add Exit/Sortie Section */}
        <div>
          <Col span={9}>
            <AntTitle className="mb-2 color-blue mt-4" level={3}>
              <GetLabel label="exit" />
              {isEditable && (
                <IPen
                  onClick={handleEditClick(5)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </AntTitle>
          </Col>

          <div className="mb-3">
            <GetLabel label="conversionType" className="font-weight-400 mr-4" />
            <Text className="font-weight-500">
              {sortieData?.isAutomaticConversion
                ? 'Automatic Conversion'
                : 'Capital Repayment'}
            </Text>
          </div>

          {sortieData?.isAutomaticConversion && (
            <>
              <div className="mb-3">
                <GetLabel
                  label="targetProduct"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  {sortieData?.targetprcode || '-'}
                </Text>
              </div>
              <div className="mb-3">
                <GetLabel
                  label="targetOffer"
                  className="font-weight-400 mr-4"
                />
                <Text className="font-weight-500">
                  {sortieData?.offerlabel || sortieData?.offeridtarget || '-'}
                </Text>
              </div>
            </>
          )}
        </div>

        {/* Conversions Section */}
        <div>
          <Col span={12}>
            <AntTitle className="mb-2 color-blue mt-4" level={3}>
              <GetLabel label="conversion" />
              {isEditable && (
                <IPen
                  onClick={handleEditClick(6)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </AntTitle>
          </Col>
          <Row
            className="mb-4 pl-1 pr-1"
            gutter={16}
            align="middle"
            justify="space-between"
          >
            <Col span={8} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="productfamily"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={8} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="productname"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
            <Col span={8} className="align-center text-center pr-4 pl-4">
              <GetLabel
                label="productdescription"
                className=" font-size-13 font-weight-600 gray-color"
              />
            </Col>
          </Row>

          {conversionList?.length === 0 ? (
            <Card
              style={{ zIndex: 100 }}
              className="no-border-radius no-border text-center mb-2"
            >
              <GetLabel
                label="empty-conversion"
                className="font-size-13 gray-color"
              />
            </Card>
          ) : (
            conversionList?.map((item, index) => (
              <div
                key={item.offercodetarget || index}
                style={{ zIndex: 100, padding: 5 }}
                className="activity-card mb-2"
              >
                <Row gutter={16} align="middle" justify="space-between">
                  <Col span={8} className="text-center">
                    {item.producttarget || '-'}
                  </Col>
                  <Col span={8} className="text-center">
                    {item.offercodetarget || '-'}
                  </Col>
                  <Col span={8} className="text-center">
                    {item.offerlabel || '-'}
                  </Col>
                </Row>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductRecapContent;
